import { useCallback } from "react";
import MainNavbar from "components/Navbar/MainNavbar";
import * as Track from "@qoohoo/common/utils/analytics/track";
import IndexFooter from "../components/IndexFooter";
import { appStoreUrl, playStoreUrl } from "../constants/constants";
import { useEffect } from "react";
import { button, link, pageview } from "@qoohoo/common/constants/analytics";

const currentScreen = pageview.download;
export default function Downloads() {
  useEffect(() => {
    Track.pageView(currentScreen);
  }, []);

  return (
    <>
      <div className="relative flex flex-col items-center w-full min-h-screen text-white">
        <div className="w-full">
          <MainNavbar currentScreen={currentScreen}/>
        </div>

        <div className="relative flex flex-col items-center w-full overflow-visible text-center sm:justify-center sm:px-10">
          <div className="relative min-w-[212px] w-[212px] sm:w-[340px] max-w-[324px] mx-auto overflow-visible min-h-[247px] sm:min-h-[293px] mt-[32px] md:mt-[72px]">
            <div className="absolute hidden -left-16 top-24 sm:block">
              <img src="/assets/images/downloads-1.svg" alt="jumping man" />
            </div>
            <div className="absolute -top-1 -right-6 sm:-top-7 sm:-right-4 w-[96.25px] sm:w-auto">
              <img src="/assets/images/downloads-2.svg" alt="lady doing yoga" />
            </div>
            <div className="absolute top-[4.5rem] -left-8 sm:left-auto sm:top-40 sm:-right-12 w-[84px] sm:w-auto">
              <img src="/assets/images/downloads-3.svg" alt="jar of coins" />
            </div>
            <div className="absolute mx-auto w-full h-[340px] sm:h-[440px] z-[-1] bg-gradient-to-b from-transparent to-[#16191B]" />
            <div className="absolute inset-0 mx-auto z-[-2]">
              <img
                src="/assets/images/png-frame.png"
                alt="mobile frame"
                className="mx-auto"
              />
            </div>
          </div>
          <div className="flex flex-col items-center justify-center -mt-12 sm:-mt-4">
            <h1 className=" text-[40px] sm:text-[80px] leading-[54px] sm:leading-[108px] font-extrabold tracking-[0.01em]">
              Download now!
            </h1>
            <div className="px-0 mt-4 sm:px-9 sm:mt-5">
              <p className="text-base leading-[22.4px] sm:text-xl font-normal w-[299px] sm:w-[486px] tracking-[0.01em]">
                India's first comprehensive platform to grow, engage and
                monetize your community
              </p>
            </div>

            <div className="flex flex-row items-center justify-center mt-10 sm:mt-14 sm:mb-36 w-[312px] sm:w-[462px]">
              <a
                href={playStoreUrl}
                onClick={useCallback(() => {
                  Track.buttonClick(button.download_app, {
                    platform_target: "android",
                    url: playStoreUrl,
                    current_screen: pageview.download,
                  });
                })}
              >
                <img
                  src="/assets/google-play-badge.svg"
                  className="h-[46px] sm:h-16 w-[138px] sm:w-[215px] mr-6"
                />
              </a>
              <a
                href={appStoreUrl}
                onClick={useCallback(() => {
                  Track.linkClick(link.download_app, {
                    platform_target: "ios",
                    url: appStoreUrl,
                    current_screen: pageview.download,
                  });
                })}
              >
                <img
                  src="/assets/icons/app-store-badge-2.svg"
                  className="h-[46px] sm:h-16 w-[138px] sm:w-[215px]"
                />
              </a>
            </div>
          </div>
          <img
            src="/assets/icons/smoothcorner3.svg"
            alt="404 Stars"
            className="absolute z-[-2] top-[16%] w-5 hidden sm:block h-5 sm:h-auto sm:w-auto sm:top-8 sm:right-20 lg:right-56 select-none"
          />
          <img
            src="/assets/icons/smoothcorner2.svg"
            alt="404 Stars"
            className="absolute z-[-2] top-16 right-3 w-[18px] h-[18px] sm:h-auto sm:w-auto sm:top-80 sm:right-[120px] lg:right-[131px] select-none"
          />
          <img
            src="/assets/icons/smoothcorner1.svg"
            alt="404 Stars"
            className="absolute z-[-2] left-[14px] top-28 w-4 sm:w-5 lg:top-[296px] lg:left-[90px] max-w-6 max-h-6 select-none"
          />
          <img
            src="/assets/icons/smoothcorner4.svg"
            alt="404 Stars"
            className="absolute z-[-2] h-auto w-auto left-40 lg:top-[107px] lg:left-[215px] max-w-6 max-h-6x hidden sm:block select-none"
          />

          <img
            src="/assets/icons/smoothcorner3.svg"
            alt="404 Stars"
            className="absolute z-[-2] left-[89px] w-5 h-5 sm:hidden select-none"
          />
        </div>
        <div className="w-full mt-16 sm:mt-4">
          <img
            src="/assets/images/wave.svg"
            alt="Wave illustration seperating FAQ and CTA sections"
            className="hidden w-full select-none md:block"
          />
          <img
            src="/assets/images/wave-mobile.svg"
            alt="Wave illustration seperating FAQ and CTA sections"
            className="w-full select-none md:hidden"
          />
          <IndexFooter />
        </div>
      </div>
    </>
  );
}
